// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#e8b017',
        secondary: '#121212',
        success: '#1daa89',
        warning: '#ff9900',
        error: '#F11A16',
      },
      dark: {
        primary: '#e8b017',
        secondary: '#1E1E1E',
        success: '#1daa89',
        warning: '#ff9900',
        error: '#F11A16',
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
  },
});
